import { Link } from 'react-router-dom';


import './../../pages/properties/property.css'; // TODO Should we share this or move it!?

export const UserTile = ({user}) => {

    const userImagePath = user => {
        // TODO: I hacked the API using ADO portal...! its not right. Need to fix broken integration tests which I skipped temporartily to get the hacked build through.
        return user.thumbnailProfileImageIncludingSasToken;
    }

    const imageNotAvailableClass = user => {
        const result = "property product" + (userImagePath(user) ? "" : " not-available");
        return result;
    }

    const imageStyle = user => {
        const unknown = { marginTop: "20px", alignSelf: "center", maxHeight: "180px", width: "50%", backgroundImage: 'url(/assets/img/pos/unknown-user.png)' };

        
        const known = { backgroundImage: `url(${userImagePath(user)})`, width: "180px", height: "180px", borderRadius: "50%", marginLeft: "auto", marginRight: "auto"};
        return userImagePath(user) ? known : unknown;
    }

    return (

        <div key={`user-${user.id}`}>
            <Link to={`/user/${user.id}`} className={imageNotAvailableClass(user)}>
                <div className="img mt-3" style={imageStyle(user)}></div>
                <div className="text">
                    <div className="property-description text-truncate">{user.displayName}</div>
                    <div className="property-first-line text-truncate">{user.phoneNumber}</div>
                    <div className="property-first-line text-truncate">{user.companyName}</div>
                    <div className="postcode text-truncate">{user.emailAddress}</div>
                </div>
                {!userImagePath(user) && (
                    <div className="not-available-text">
                        <div>Image Not Available</div>
                    </div>
                )}
            </Link>
        </div>

    );

};